export default {
    manage_createEditWorkOrderStatus_editTitle: "Edit Work Order Status",
    manage_createEditWorkOrderStatus_createTitle: "Create New Work Order Status",
    manage_createEditWorkOrderStatus_createSuccess: "Work order status saved",
    manage_createEditWorkOrderStatus_name: "Name",
    manage_createEditWorkOrderStatus_description: "Description",
    manage_createEditWorkOrderStatus_duplicatedName: "Name is already in use",
    manage_createEditWorkOrderStatus_category: "Category",
    manage_createEditWorkOrderStatus_todo: "To Do",
    manage_createEditWorkOrderStatus_closed: "Closed",
    manage_createEditWorkOrderStatus_inprogress: "In Progress",
    manage_createEditWorkOrderStatus_inroute: "In Route",
}